var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-signup-my pb24 bc-cCF5" }, [
    _c("div", { staticClass: "flex space-between w1200 mt24 align-left" }, [
      _c("div", { staticClass: "w100p bc-cCFF" }, [
        _c(
          "div",
          { staticClass: "mt24 ml32 mr32 mb32" },
          [
            _c("div", { staticClass: "fs24 mb24" }, [
              _vm._v(_vm._s(_vm.language().tit_my)),
            ]),
            _c(
              "div",
              {
                staticClass: "bc-cCFA rtl4 rtr4 rbl4 rbr4 pt24 pl24 pr24 pb24",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "mb12 fw500 fs20 ellipsis lineClamp2 word-break",
                  },
                  [
                    _c(
                      "yxtf-tag",
                      {
                        staticClass: "pl7 pr7 fs14 relative top-1",
                        attrs: {
                          coverType: "blue",
                          size: "small",
                          type: "info",
                        },
                      },
                      [_vm._v(_vm._s(_vm.data.appName))]
                    ),
                    _c("span", { attrs: { title: _vm.data.projectName } }, [
                      _vm._v(_vm._s(_vm.data.projectName)),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex space-between rtl4 rtr4 rbl4 rbr4" },
                  [
                    _c(
                      "div",
                      { staticClass: "w50p-12" },
                      [
                        _c("div", { staticClass: "mb8 c-cC8C relative" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "absolute top0 inline-block w58 justify ellipsis",
                            },
                            [_vm._v(_vm._s(_vm.language().lbl_admin))]
                          ),
                          _c("span", { staticClass: "absolute top0 left58" }, [
                            _vm._v("："),
                          ]),
                          _c(
                            "span",
                            { staticClass: "c-cC26 block pl70" },
                            [
                              _c("yxtbiz-user-name", {
                                attrs: {
                                  slot: "content",
                                  name:
                                    (_vm.data.owners || [])
                                      .map(function (_) {
                                        return _.fullname
                                      })
                                      .join("、") || "--",
                                  split: "、",
                                },
                                slot: "content",
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._l(_vm.extendedInfo, function (info, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              class: "c-cC8C relative " + (index ? "mt8" : ""),
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "absolute top0 inline-block w58 justify ellipsis",
                                },
                                [_vm._v(_vm._s(info.label))]
                              ),
                              _c(
                                "span",
                                { staticClass: "absolute top0 left58" },
                                [_vm._v("：")]
                              ),
                              _c("span", { staticClass: "c-cC26 block pl70" }, [
                                _vm._v(_vm._s(info.value || "--")),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm.data.pointPrice
                      ? _c(
                          "div",
                          { staticClass: "w50p-12 align-right flex-end" },
                          [
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "mb8 c-cC8C relative" },
                                [
                                  _c("span", { staticClass: "inline-block" }, [
                                    _vm._v(
                                      _vm._s(_vm.language().lbl_total_cost)
                                    ),
                                  ]),
                                  _c("span", { staticClass: "inline-block" }, [
                                    _vm._v("："),
                                  ]),
                                  _c(
                                    "span",
                                    { staticClass: "inline-block c-cC26" },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "d-integral relative top-5",
                                        attrs: {
                                          src:
                                            _vm.$staticBaseUrl +
                                            "assets/141df7bc/85e5b524/a27406.svg",
                                          alt: "",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "ml4 c-cC26 fs24 fw500",
                                        },
                                        [_vm._v(_vm._s(_vm.data.pointPrice))]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "ml4 c-cC75 relative top-3",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.language().msg_integral)
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm.points.totalMallPoint
                                ? _c(
                                    "div",
                                    { staticClass: "c-cC8C relative" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "inline-block" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.language()
                                                .lbl_available_points
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "inline-block" },
                                        [_vm._v("：")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "inline-block c-cC26" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.points.totalMallPoint.toLocaleString()
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        )
                      : _c(
                          "div",
                          { staticClass: "w50p-12 align-right flex-end" },
                          [
                            _c(
                              "div",
                              { staticClass: "c-cC8C relative top-2" },
                              [
                                _c("span", { staticClass: "inline-block" }, [
                                  _vm._v(_vm._s(_vm.language().lbl_total_cost)),
                                ]),
                                _c("span", { staticClass: "inline-block" }, [
                                  _vm._v("："),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "inline-block c-cC59 fw500 fs20",
                                  },
                                  [_vm._v(_vm._s(_vm.language().msg_free))]
                                ),
                              ]
                            ),
                          ]
                        ),
                  ]
                ),
              ]
            ),
            !_vm.data.userOtherEnrolled
              ? _c(
                  "div",
                  { staticClass: "ml24 mt24 inline-block" },
                  [
                    [0, 1, 2, 5].includes(_vm.info.auditStatus)
                      ? [
                          _vm.info.orderCode && _vm.data.pointPrice
                            ? _c(
                                "div",
                                { staticClass: "mb15 c-cC8C relative h24" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "absolute top0 inline-block w58 justify ellipsis",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.language().lbl_order_number)
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "absolute top0 left58" },
                                    [_vm._v("：")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "c-cC26 block pl70" },
                                    [_vm._v(_vm._s(_vm.info.orderCode))]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.info.orderCreateTime && _vm.data.pointPrice
                            ? _c(
                                "div",
                                { staticClass: "mb15 c-cC8C relative h24" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "absolute top0 inline-block w58 justify ellipsis",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.language().lbl_creation_time)
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "absolute top0 left58" },
                                    [_vm._v("：")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "c-cC26 block pl70" },
                                    [_vm._v(_vm._s(_vm.info.orderCreateTime))]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "mb15 c-cC8C relative h24" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "absolute top0 inline-block w58 justify ellipsis",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.language().lbl_registration_status
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticClass: "absolute top0 left58" },
                                [_vm._v("：")]
                              ),
                              _c("span", { staticClass: "c-cC26 block pl70" }, [
                                _c(
                                  "span",
                                  {
                                    class:
                                      "fw500 fs16 " +
                                      (_vm.info.auditStatus === 2
                                        ? "c-cCRed"
                                        : _vm.info.auditStatus === 0
                                        ? "c-cCOrange"
                                        : ""),
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$parent.auditStatusObj[
                                          _vm.info.auditStatus
                                        ].label || ""
                                      )
                                    ),
                                  ]
                                ),
                                _vm.$parent.auditStatusObj[_vm.info.auditStatus]
                                  .info
                                  ? _c("span", { staticClass: "c-cC75" }, [
                                      _vm._v(
                                        "（" +
                                          _vm._s(
                                            _vm.$parent.auditStatusObj[
                                              _vm.info.auditStatus
                                            ].info || ""
                                          ) +
                                          "）"
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                          _vm.info.auditStatus === 5
                            ? _c(
                                "div",
                                { staticClass: "mb15 c-cC8C relative h24" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "absolute top0 inline-block w58 justify ellipsis",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language().lbl_alternate_position
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "absolute top0 left58" },
                                    [_vm._v("：")]
                                  ),
                                  _vm.info.substituteOrder
                                    ? _c(
                                        "span",
                                        { staticClass: "c-cC26 block pl70" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm
                                                .language()
                                                .msg_alternate_position.replace(
                                                  "$num",
                                                  _vm.info.substituteOrder
                                                )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ]
                      : [3].includes(_vm.info.auditStatus)
                      ? [
                          _c(
                            "div",
                            { staticClass: "mb15 c-cC8C relative h24" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "absolute top0 inline-block w58 justify ellipsis",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.language().lbl_registration_status
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticClass: "absolute top0 left58" },
                                [_vm._v("：")]
                              ),
                              _c(
                                "span",
                                { staticClass: "c-cCRed block pl70" },
                                [
                                  _c("span", { staticClass: "fw500 fs16" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$parent.auditStatusObj[
                                          _vm.info.auditStatus
                                        ].label || ""
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "mb15 c-cC8C relative h24" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "absolute top0 inline-block w58 justify ellipsis",
                                },
                                [_vm._v(_vm._s(_vm.language().lbl_abandoner))]
                              ),
                              _c(
                                "span",
                                { staticClass: "absolute top0 left58" },
                                [_vm._v("：")]
                              ),
                              _vm.info.fullname
                                ? _c(
                                    "span",
                                    { staticClass: "c-cC26 block pl70" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "mr24" },
                                        [
                                          _c("yxtf-portrait", {
                                            staticClass: "h24 wh24",
                                            attrs: {
                                              size: "small",
                                              imgUrl: _vm.info.imgUrl,
                                              username: _vm.info.fullname,
                                            },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "relative top-6 ml4",
                                            },
                                            [
                                              _c("yxtbiz-user-name", {
                                                attrs: {
                                                  slot: "content",
                                                  name: _vm.info.fullname,
                                                },
                                                slot: "content",
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "mb15 c-cC8C relative h24" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "absolute top0 inline-block w58 justify ellipsis",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.language().lbl_give_up_time)
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticClass: "absolute top0 left58" },
                                [_vm._v("：")]
                              ),
                              _vm.info.actionTime && _vm.info.auditStatus === 3
                                ? _c(
                                    "span",
                                    { staticClass: "c-cC26 block pl70" },
                                    [_vm._v(_vm._s(_vm.info.actionTime))]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "mb15 c-cC8C relative h24" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "absolute top0 inline-block w58 justify ellipsis",
                                },
                                [_vm._v(_vm._s(_vm.language().lbl_reasons))]
                              ),
                              _c(
                                "span",
                                { staticClass: "absolute top0 left58" },
                                [_vm._v("：")]
                              ),
                              _vm.info.reason
                                ? _c(
                                    "span",
                                    { staticClass: "c-cC26 block pl70" },
                                    [_vm._v(_vm._s(_vm.info.reason))]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      : [4].includes(_vm.info.auditStatus)
                      ? [
                          _c(
                            "div",
                            { staticClass: "mb15 c-cC8C relative h24" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "absolute top0 inline-block w58 justify ellipsis",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.language().lbl_registration_status
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticClass: "absolute top0 left58" },
                                [_vm._v("：")]
                              ),
                              _c(
                                "span",
                                { staticClass: "c-cCRed block pl70" },
                                [
                                  _c("span", { staticClass: "fw500 fs16" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$parent.auditStatusObj[
                                          _vm.info.auditStatus
                                        ].label || ""
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "mb15 c-cC8C relative h24" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "absolute top0 inline-block w58 justify ellipsis",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.language().lbl_operator || "")
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticClass: "absolute top0 left58" },
                                [_vm._v("：")]
                              ),
                              _c("span", { staticClass: "c-cC26 block pl70" }, [
                                _c(
                                  "span",
                                  { staticClass: "mr24" },
                                  [
                                    _c("yxtf-portrait", {
                                      staticClass: "h24 wh24",
                                      attrs: {
                                        size: "small",
                                        imgUrl: _vm.info.optGiveUpUserImgUrl,
                                        username:
                                          _vm.info.optGiveUpUserfullname,
                                      },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "relative top-6 ml4" },
                                      [
                                        _c("yxtbiz-user-name", {
                                          attrs: {
                                            name: _vm.info
                                              .optGiveUpUserfullname,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "mb15 c-cC8C relative h24" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "absolute top0 inline-block w58 justify ellipsis",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.language().lbl_operation_time)
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticClass: "absolute top0 left58" },
                                [_vm._v("：")]
                              ),
                              _vm.info.actionTime
                                ? _c(
                                    "span",
                                    { staticClass: "c-cC26 block pl70" },
                                    [_vm._v(_vm._s(_vm.info.actionTime))]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : [
                  _c(
                    "div",
                    { staticClass: "ml24 mt24" },
                    [
                      _c(
                        "yxtf-select",
                        {
                          staticClass: "w180",
                          attrs: {
                            clearable: "",
                            placeholder: _vm.language().lbl_registration_status,
                          },
                          on: { change: _vm.searchPage },
                          model: {
                            value: _vm.auditValue,
                            callback: function ($$v) {
                              _vm.auditValue = $$v
                            },
                            expression: "auditValue",
                          },
                        },
                        _vm._l(_vm.$parent.auditStatus, function (item, index) {
                          return _c("yxtf-option", {
                            key: index,
                            attrs: {
                              label:
                                item.label +
                                (item.info ? "（" + item.info + "）" : ""),
                              value: item.value,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "ml24 mt24" },
                    [
                      _c(
                        "yxtf-table",
                        {
                          staticClass: "w100p table-cell-right12",
                          attrs: { data: _vm.list },
                        },
                        [
                          _c("yxtf-table-column", {
                            attrs: { label: _vm.language().lbl_registrants },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("yxtbiz-user-name", {
                                      attrs: {
                                        name: scope.row.fullname || "--",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("yxtf-table-column", {
                            attrs: {
                              label: _vm.language().lbl_registration_method,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          (
                                            _vm.$parent.enrollTypeObj[
                                              scope.row.enrollType
                                            ] || {}
                                          ).label || "--"
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("yxtf-table-column", {
                            attrs: {
                              label: _vm.language().lbl_registration_status,
                              width: "275",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", {
                                      class: [
                                        scope.row.auditStatus === 1 ||
                                        scope.row.auditStatus === 5
                                          ? "bc-cCGreen"
                                          : scope.row.auditStatus === 0
                                          ? "bc-cCOrange"
                                          : "bc-cCD8",
                                        "relative top-2 dot",
                                      ],
                                    }),
                                    _c("span", { staticClass: "mr4" }, [
                                      _vm._v(
                                        _vm._s(
                                          ((
                                            _vm.$parent.auditStatusObj[
                                              scope.row.auditStatus
                                            ] || {}
                                          ).label || "") +
                                            ((
                                              _vm.$parent.auditStatusObj[
                                                scope.row.auditStatus
                                              ] || {}
                                            ).info
                                              ? "（" +
                                                _vm.$parent.auditStatusObj[
                                                  scope.row.auditStatus
                                                ].info +
                                                "）"
                                              : "")
                                        )
                                      ),
                                    ]),
                                    scope.row.auditStatus === 3 ||
                                    scope.row.auditStatus === 4
                                      ? _c(
                                          "yxtf-popover",
                                          {
                                            attrs: {
                                              placement: "top",
                                              title:
                                                scope.row.auditStatus === 3
                                                  ? _vm.language().lbl_y_give_up
                                                  : _vm.language()
                                                      .lbl_disqualified,
                                              width: 260,
                                              trigger: "hover",
                                              "visible-arrow": true,
                                            },
                                          },
                                          [
                                            _c("yxtf-svg", {
                                              staticClass:
                                                "relative top4 c-cC8C",
                                              attrs: {
                                                slot: "reference",
                                                width: "18px",
                                                height: "18px",
                                                "icon-class": "prompt-0",
                                              },
                                              slot: "reference",
                                            }),
                                            _c(
                                              "div",
                                              { staticClass: "yxtbiz-signup" },
                                              [
                                                scope.row.auditStatus === 3
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mah100" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "c-cC8C relative h24 ellipsis",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.language()
                                                                    .lbl_abandoner
                                                                ) +
                                                                "：\n                          "
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "c-cC26",
                                                              },
                                                              [
                                                                _c(
                                                                  "yxtbiz-user-name",
                                                                  {
                                                                    attrs: {
                                                                      name:
                                                                        scope
                                                                          .row
                                                                          .optGiveUpUserfullname ||
                                                                        "--",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "c-cC8C relative h24",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.language()
                                                                    .lbl_give_up_time
                                                                ) +
                                                                "："
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "c-cC26",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row
                                                                      .actionTime
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "c-cC8C relative h241",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.language()
                                                                    .lbl_reasons
                                                                ) +
                                                                "："
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "c-cC26",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row
                                                                      .reason
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      { staticClass: "mah100" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "c-cC8C relative h24 ellipsis",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.language()
                                                                    .lbl_operator
                                                                ) +
                                                                "："
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "c-cC26",
                                                              },
                                                              [
                                                                _c(
                                                                  "yxtbiz-user-name",
                                                                  {
                                                                    attrs: {
                                                                      name: scope
                                                                        .row
                                                                        .optGiveUpUserfullname,
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "c-cC8C relative h24",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.language()
                                                                    .lbl_operation_time
                                                                ) +
                                                                "："
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "c-cC26",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row
                                                                      .actionTime
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm.isShowAbandoner
                            ? _c("yxtf-table-column", {
                                attrs: { label: _vm.language().lbl_abandoner },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("yxtbiz-user-name", {
                                            attrs: {
                                              name:
                                                scope.row
                                                  .optGiveUpUserfullname ||
                                                "--",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3836472746
                                ),
                              })
                            : _vm._e(),
                          _c("yxtf-table-column", {
                            attrs: {
                              label: _vm.language().lbl_operation,
                              width: "124",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    [0, 1, 5].includes(scope.row.auditStatus) &&
                                    _vm.timeValue <
                                      new Date(
                                        _vm.data.giveUpDeadline
                                      ).valueOf()
                                      ? _c(
                                          "span",
                                          {
                                            class:
                                              "fs14 " +
                                              (_vm.factor
                                                ? "pointer c-cC436BFF"
                                                : "not-allowed c-cCBF"),
                                            on: {
                                              click: function ($event) {
                                                return _vm.cancel(scope.row.id)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.language().btn_give_up)
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("yxtf-pagination", {
                    staticClass: "mt24 align-right",
                    attrs: {
                      layout: "prev, pager, next",
                      "current-page": _vm.current,
                      total: _vm.total,
                      "page-size": _vm.size,
                    },
                    on: {
                      "update:currentPage": function ($event) {
                        _vm.current = $event
                      },
                      "update:current-page": function ($event) {
                        _vm.current = $event
                      },
                      "current-change": _vm.search,
                    },
                  }),
                ],
            _c(
              "div",
              { staticClass: "ml24 mt32 center" },
              [
                !_vm.data.userOtherEnrolled &&
                [0, 1, 5].includes(_vm.info.auditStatus) &&
                _vm.timeValue <
                  new Date(
                    (_vm.data.giveUpDeadline || "").replace(/-/g, "/")
                  ).valueOf()
                  ? _c(
                      "yxtf-button",
                      {
                        attrs: { size: "larger2", disabled: !_vm.factor },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.cancel()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.language().btn_give_up))]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }